<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 订单记录 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="门店仓库">
          <customer-store-select
            :defaultFirst="true"
            style="width: 180px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select
            v-model="formInline.optCancel"
            @change="queryClick"
            style="width: 140px; margin-right: 10px"
            placeholder="订单状态"
          >
            <el-option label="全部类型" value=""></el-option>
            <el-option label="正常订单" value="0"></el-option>
            <el-option label="取消订单" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单类型">
          <el-select
            v-model="formInline.orderType"
            @change="queryClick"
            style="width: 140px; margin-right: 10px"
            placeholder="订单类型"
          >
            <el-option label="全部类型" value=""></el-option>
            <el-option label="线下订单" value="offline"></el-option>
            <el-option label="渠道订单" value="other"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单渠道" v-if="formInline.orderType == 'other'">
          <customer-order-channel-select
            v-model="formInline.orderChannelGuid"
            @change="queryClick"
            style="width: 140px; margin-right: 10px"
            :clearable="true"
            placeholder="订单渠道"
          />
        </el-form-item>
        <el-form-item label="搜索内容">
          <el-input
            v-model="formInline.queryValue"
            @change="queryClick"
            style="width: 240px"
            placeholder="关键词"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="hover">
      <div style="padding: 10px">
        <time-range @change="handleTimeChange">
          <template slot="append">
            <div style="margin-right: 10px">
              <el-button type="default" @click="exportClick"> 导出记录 </el-button>
              <el-button type="primary" @click="createClick" :size="$xUISize">
                创建新订单
              </el-button>
            </div>
          </template>
        </time-range>
        <div v-if="storeGuid && times">
          <x-table
            ref="list"
            listApi="biz.warehouse.order.info.list"
            paginationLayout="total, sizes, prev, next, jumper"
            actionFixed="right"
            emptyLabel="暂无订单信息"
            :fieldList="fieldList"
            :actionList="actionList"
            :defaultParams="defaultParams"
            :actionWidth="220"
          >
            <template slot="row-info" slot-scope="scope">
              <warehouse-order-info
                :showCount="true"
                :orderInfo="scope.row"
                :showStatus="scope.row.customerGuid != '1236952854388871168'"
                @inventoryListClick="inventoryListClick"
                @paymentListClick="paymentListClick"
                @prescriptionListClick="prescriptionListClick"
                @refundListClick="refundListClick"
              >
                <template slot="action">
                  <el-select
                    v-if="
                      scope.row.customerGuid == '1236952854388871168' &&
                      scope.row.optCancel == 0
                    "
                    style="width: 100px"
                    placeholder="自定义状态"
                    @change="handleChangeTagLabel($event, scope.row)"
                    :value="scope.row.tagLabel"
                  >
                    <el-option label="无" value=""></el-option>
                    <el-option label="待发货" value="待发货"></el-option>
                    <el-option label="已完成" value="已完成"></el-option>
                  </el-select>
                </template>
              </warehouse-order-info>
            </template>
          </x-table>
        </div>
        <el-empty v-else description="请选择门店" :image-size="100"> </el-empty>
      </div>
    </el-card>
    <el-dialog
      title="提示"
      append-to-body
      :show-close="false"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :visible="printLoading"
      width="400px"
    >
      <span>
        <i class="el-icon-loading"></i>
        正在打印中
      </span>
    </el-dialog>
  </div>
</template>

<script>
import timeRange from "../../../../components/timeRange.vue";
import warehouseOrderInfo from "../../../../components/business/warehouseOrderInfo.vue";
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import customerOrderChannelSelect from "../../../../components/business/customerOrderChannelSelect.vue";
import orderDetail from "./detail.vue";
import orderPayment from "./__payment.vue";
import orderCreate from "./__recreate.vue";
import exportPage from "./__index_export.vue";

export default {
  components: {
    timeRange,
    warehouseOrderInfo,
    customerStoreSelect,
    customerOrderChannelSelect,
  },
  props: {
    tabName: {
      type: String,
    },
    tabProps: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
    },
  },
  computed: {
    defaultParams() {
      return Object.assign(
        {
          storeGuid: this.storeGuid,
        },
        this.queryModel || {},
        this.times
      );
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  methods: {
    refresh() {
      if (this.$refs.list) {
        this.$refs.list.refresh();
      }
    },
    exportClick() {
      this.$drawer.openDrawer(
        {
          title: "导出记录",
          refresh: this.refresh,
          component: exportPage,
          params: {},
        },
        true
      );
    },
    clearClick() {
      this.formInline = {
        orderType: "",
        orderChannelGuid: "",
        queryValue: "",
        optCancel: "",
      };
      this.queryModel = {};
    },
    queryClick() {
      if (this.formInline.orderType != "other") {
        this.formInline.orderChannelGuid = "";
      }
      this.queryModel = Object.assign({}, this.formInline);
    },
    createClick() {
      this.$drawer.openDrawer({
        title: "创建新订单",
        refresh: this.refresh,
        component: orderCreate,
        params: {
          storeGuid: this.storeGuid,
        },
      });
    },
    handleTimeChange(time) {
      this.times = time;
    },
    openDetailPage(row, tabName) {
      this.$drawer.openDrawer({
        title: "销售订单详细信息",
        refresh: this.refresh,
        component: orderDetail,
        params: {
          guid: row.guid,
          storeGuid: row.storeGuid,
          tabName: tabName,
        },
      });
    },
    inventoryListClick(row) {
      this.openDetailPage(row, "order-inventory");
    },
    paymentListClick(row) {
      this.openDetailPage(row, "order-payment");
    },
    refundListClick(row) {
      this.openDetailPage(row, "order-refund");
    },
    prescriptionListClick(row) {
      this.openDetailPage(row, "order-prescription");
    },
    handleChangeTagLabel(value, row) {
      this.requestApi(
        "biz.warehouse.order.info.setTagLabel",
        {
          guid: row.guid,
          storeGuid: row.storeGuid,
          tagLabel: value,
        },
        { showError: true }
      ).then(() => {
        this.refresh();
      });
    },
  },
  data() {
    return {
      times: null,
      storeGuid: "",
      printLoading: false,
      queryModel: {},
      formInline: {
        orderType: "",
        orderChannelGuid: "",
        queryValue: "",
        optCancel: "",
      },
      fieldList: [
        {
          label: "订单信息",
          minWidth: "280",
          slot: "info",
        },
      ],
      actionList: [
        {
          label: "详情",
          linkType: "primary",
          click: (row, tag, refresh) => {
            this.openDetailPage(row);
          },
        },
        {
          label: "打印单据",
          disabled: (row) => {
            return row.optCancel != 0;
          },
          click: (row, tag, refresh) => {
            this.printOrder(row);
          },
        },
        {
          label: "发起收款",
          linkType: "primary",
          show: (row) => {
            return row.optCancel == 0 && row.optStatus == 1;
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "销售订单收款",
              refresh: refresh,
              component: orderPayment,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
        {
          label: "重新创建",
          linkType: "primary",
          show: (row) => {
            return row.optCancel == 2 && row.autoOutbound == 1;
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "创建新订单",
              refresh: refresh,
              component: orderCreate,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
        {
          label: "取消",
          linkType: "danger",
          disabled: (row) => {
            return row.optCancel != 0;
          },
          click: (row, tag, refresh) => {
            this.$confirm(`确定取消订单，此操作不可恢复，请谨慎操作?`, "提示", {
              type: "warning",
            }).then(() => {
              this.requestApi(
                "biz.warehouse.order.info.cancel",
                {
                  guid: row.guid,
                  storeGuid: row.storeGuid,
                },
                { showError: true }
              ).then(() => {
                refresh();
              });
            });
          },
        },
      ],
    };
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
  },
};
</script>
